/* istanbul ignore file */
import { Button } from '@distribusion/owl-frontend-ui'
import { Field, Form, useFormikContext } from 'formik'
import React from 'react'

import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'
import { email, required, chain } from '@lib/validators'
import { ForgotPasswordButton } from '@pages/Account/Settings/Modals/ForgotPasswordButton'
import InputField from '@ui/Input/Field'
import PasswordField from '@ui/Input/PasswordField'

interface LoginFormProps {
  onForgotPasswordClick: () => void
}

const LoginForm = ({ onForgotPasswordClick }: LoginFormProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()

  return (
    <Form>
      <div className="row gap-3 wrap">
        <div className={bem('login-modal', 'email')}>
          <Field
            component={InputField}
            label={t('subscription.loginModal.email')}
            name="email"
            validate={chain([required, email])}
            required
          />
        </div>
        <div className="row gap-3 wrap">
          <div className={bem('login-modal', 'password')}>
            <Field component={PasswordField} label={t('subscription.loginModal.password')} name="password" required />
          </div>
        </div>
        <ForgotPasswordButton onClick={onForgotPasswordClick} />
        <div className={bem('login-modal', 'button')}>
          <Button buttonType="submit" disabled={isSubmitting}>
            <span>{t('subscription.loginModal.button')}</span>
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default LoginForm
